<template>
  <HeaderContent title="CheckIn Lists" />
  <ActionContent
    :cta="false"
    :filter-modal="false"
    @action="toggleModal"
    @showFilter="toggleFilterModal"
    v-model:start-date="startDate"
    v-model:end-date="endDate"
    v-model:search="search"
    @search-query="handleSearch"
  />

  <CheckInStatistics title="Check In Statistics" :data="statistics" />
  <PaymentForm
    :modal="modalPayment"
    :uuid="reservationUuid"
    @update:modal="modalPayment = $event"
    @paid="getAll"
  />
  <ExtrachargeForm
    :modal="modalExtraCharge"
    :uuid="reservationUuid"
    @update:modal="modalExtraCharge = $event"
    @addedExtraCharge="getAll"
  />
  <CheckInForm :modal="modal" @update:modal="modal = $event" />

  <ReservationInformation
    :modal="modalInformation"
    :reservationData="reservationData"
    @update:modal="modalInformation = $event"
  />

  <CheckInConfirm
    title="CheckIn Confirmation"
    :uuid="reservationUuid"
    :dataPriview="dataPriview"
    :data="checkin"
    :actionType="actionType"
    :modalConfirm="modalCheckIn"
    v-model="modalCheckIn"
    @confirmed="handleModalConfirmation"
  >
    <template #body>
      <div class="guest-info text-start" id="printArea">

        <!--  Kop & logo (print)  -->
        <div class="print-only text-center">
          <table class="w-full text-center border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-center pr-2">
                  <img
                    src="../../../public/img/hotel-deliriver.png"
                    alt="Deli River Hotel Logo"
                    style="width: 100px; height: auto"
                  />
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left pr-2">
                  <h3 class="mt-2 mb-0 text-left">Deli River Hotel</h3>
                  <p class="mb-0 text-left">
                    Jl. Raya Namorambe No. 129, Medan, Indonesia
                  </p>
                  <p class="mb-0 text-left">www.hotel-deliriver.com</p>
                  <p class="mb-0 text-left">contact@hotel-deliriver.com</p>
                </td>
              </tr>
            </tbody>
          </table>
          <hr />
        </div>

        <h4 class="print-only text-align-center">CheckIn Invoice</h4>

        <!-- =====================  GUEST INFORMATION  ===================== -->
        <div>
          <p class="text-secondary fw-semibold">Guest Information</p>

          <table class="w-full text-left border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-left">Res. Number</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.number ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left">Name</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.guest?.fullname ?? "-" }}
                </td>
              </tr>
              <!-- <tr class="border-b border-transparent">
                <td class="text-left">Contact</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  0{{ checkin?.reservation?.guest?.phone ?? "-" }}
                </td>
              </tr> -->
              <tr class="border-b border-transparent">
                <td class="text-left">Check In</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ dateFormatter(checkin?.check_in_date) ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left">Check Out</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ dateFormatter(checkin?.check_out_date) ?? "-" }}
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left">Duration</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{
                    countDays(checkin?.check_in_date, checkin?.check_out_date)
                  }}
                  night
                </td>
              </tr>
              <tr class="border-b border-transparent">
                <td class="text-left">Remark *</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.description ?? "-" }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <br />

        <!-- =====================  BILLING DETAILS  ===================== -->
        <div>
          <p class="text-secondary fw-semibold">Billing Detail</p>

          <table class="w-full text-left border-collapse">
            <tbody>
              <tr class="border-b border-transparent">
                <td class="text-left">Room Type</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.room?.room_category?.name ?? "-" }}
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left">Number</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.room?.code ?? "-" }}
                </td>
              </tr>

              <!-- tidak terlalu diperlukan, dihide aja -->
              <!-- <tr class="border-b border-transparent">
                <td class="text-left">Room Rate</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ formatIDR(getRoomPrice(checkin)) }}
                </td>
              </tr> -->

              <!-- Extra Charge -->
              <tr class="border-b border-transparent align-top">
                <td class="text-left">Extra Charge</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  <div v-if="!checkin?.reservation?.extracharge?.length">-</div>
                  <div
                    v-else
                    v-for="(item, index) in checkin?.reservation?.extracharge"
                    :key="index"
                  >
                    {{ item?.extra_charge?.name }}
                    (x{{ item?.quantity }} |
                    {{ formatIDR(item?.price ?? 0) }})
                  </div>
                </td>
              </tr>

              <!-- Payments (opsional: hapus jika tak dibutuhkan) -->
              <tr class="border-b border-transparent align-top">
                <td class="text-left">Payment</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  <div v-if="!checkin?.reservation?.payment?.length">-</div>
                  <div
                    v-else
                    v-for="(item, index) in checkin?.reservation?.payment"
                    :key="index"
                  >
                    {{ item.payment_type }}
                    ( {{ formatIDR(item.amount ?? 0) }} at
                    {{ getFormattedDate(item.payment_date) }}
                    )
                  </div>
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left">Pending Bill</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ formatIDR(sisaTagihan ?? 0) }}
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left">Total</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ formatIDR(reservation?.grand_total ?? 0) }}
                </td>
              </tr>

              <tr class="border-b border-transparent">
                <td class="text-left">Status</td>
                <td class="text-left">:</td>
                <td class="text-left fw-semibold">
                  {{ checkin?.reservation?.payment_status ?? "-" }}
                </td>
              </tr>

              <!-- Pesan status (colspan agar teks panjang cukup satu baris) -->
              <tr class="screen-only border-b border-transparent">
                <td colspan="3" class="fst-italic text-secondary">
                  This reservation has been Checked In.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
  </CheckInConfirm>

  <CheckInFilter
    :modalFilter="modalFilter"
    @update:modalFilter="modalFilter = $event"
  />
  <CheckInDataTable
    :data="checkins"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script setup>
import { ref, inject, watch, onMounted, nextTick } from "vue";
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import CheckInForm from "./CheckInForm.vue";
import CheckInFilter from "./CheckInFilter.vue";
import CheckInConfirm from "@/components/ModalDialog.vue";
import CheckInStatistics from "@/components/StatisticData.vue";
import CheckInDataTable from "@/components/DataTable.vue";
import PaymentForm from "@/components/Payment/PaymentForm.vue";
import ReservationInformation from "@/components/Reservation/ReservationInformation.vue";
import iconAlready from "../../../public/icons/assessment.svg";
import iconIncoming from "../../../public/icons/to-do.svg";
import ExtrachargeForm from "@/components/Extracharge/ExtrachargeForm.vue";
import { formatIDR } from "@/utils/currency";
import { dateFormatter } from "@/utils/dateFormatter";
import { countDays } from "@/utils/dateCalculation";
//import { useRoomPrice } from "@/composable/useRoomPrice";
import { getFormattedDate } from "@/composable/getDateTimeFormatter";

const repositories = inject("repositories");
const checkinRepository = repositories?.checkin;

const modal = ref(false);
const modalPayment = ref(false);
const modalExtraCharge = ref(false);
const modalCheckIn = ref(false);
const modalInformation = ref(false);
const modalFilter = ref(false);

const actionType = ref("checkin");
const reservationUuid = ref(null);
const reservationData = ref([]);
const checkin = ref({});

const startDate = ref(formatDate(new Date()));
const endDate = ref(formatDate(new Date()));
const search = ref("");
const filterStatus = ref({ status: null });

const statistics = ref([]);
const checkins = ref([]);

const headers = ref([
  { key: "reservation.number", label: "Reservation No", sortable: true },
  { key: "room_category", label: "Type", sortable: true },
  { key: "reservation.room.code", label: "Number", sortable: true },
  {
    key: "status_reservation",
    label: "Status",
    sortable: false,
  },
  { key: "reservation.guest.fullname", label: "Guest Name", sortable: true },
  {
    key: "check_in_date",
    label: "CheckIn at",
    sortable: true,
    formatter: (value) => getFormattedDate(value),
  },
  {
    key: "check_out_date",
    label: "CheckOut at",
    sortable: true,
    formatter: (value) => getFormattedDate(value),
  },
  {
    key: "day_left",
    label: "Duration",
    sortable: true,
    tdClass: "text-center",
  },
  {
    key: "reservation.payment_status",
    label: "Payment Status",
    sortable: true,
  },
  {
    key: "reservation.pre_payment",
    label: "Prepayment",
    sortable: true,
    tdClass: "text-right",
    formatter: (value) => formatIDR(value),
  },
  {
    key: "reservation.grand_total",
    label: "Total Bill",
    sortable: true,
    tdClass: "text-right",
    formatter: (value) => formatIDR(value),
  },
  { key: "action", label: "Actions" },
]);

const customActions = ref([
  {
    label: "Add ExtraCharge",
    variant: "warning",
    icon: "fas fa-bolt",
    action: (item) => {
      reservationUuid.value = item.reservation_uuid;
      modalExtraCharge.value = true;
    },
  },
  {
    label: "Payment",
    variant: "primary",
    icon: "fas fa-money-bill-wave-alt",
    disabled: (item) =>
      item.reservation.is_paid ||
      item.reservation.payment_status === "Full Payment",
    action: (item) => {
      //console.log("hasillll", item);
      reservationUuid.value = item.reservation_uuid;
      modalPayment.value = true;
    },
  },
  {
    label: "Check In",
    variant: "success",
    icon: "fas fa-calendar-check",
    disabled: (item) =>
      !item.reservation.is_paid ||
      item.reservation.payment_status === "DP", //||
      //item.check_in_date !== formatDate(new Date()),
    action: showConfirmModal,
  },
]);

function formatDate(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;
}

//*tidak terlalu diperlukan
// function getRoomPrice(checkin) {
//   const start = new Date(checkin?.reservation?.start);
//   const end = new Date(checkin?.reservation?.end);

//   const isHighSeason = start.getMonth() === 5 || end.getMonth() === 5; // bulan Juni

//   const category = checkin?.reservation?.room?.room_category;

//   return isHighSeason
//     ? category?.high_season_price ?? 0
//     : category?.low_season_price ?? 0;
// }

async function getAll(
  start = null,
  end = null,
  status = null,
  searchQuery = ""
) {
  const params = {};
  if (start) params.start = start;
  if (end) params.end = end;
  if (status && status !== "All") params.status = status;
  if (searchQuery) params.search = searchQuery;

  const res = await checkinRepository.getListCheckin(params);

  checkins.value = res.data.data;
  const checkinStatistics = res.data.statistics;

  statistics.value = [
    {
      label: "Total",
      key: "Already Check-In",
      value: checkinStatistics.in_house,
      color: "success",
      icon: iconAlready,
    },
    {
      label: "Total",
      key: "Incoming Check-In",
      value: checkinStatistics.incoming,
      color: "warning",
      icon: iconIncoming,
    },
  ];
}

function showConfirmModal(item) {
  reservationUuid.value = item.reservation_uuid;
  checkin.value = item;
  modalCheckIn.value = true;
}

async function handleModalConfirmation({ type, uuid, data }) {
  try {
    if (type === "checkin") {
      await checkinRepository
        .update(uuid, {
          in_house_date: data.check_in_date,
          status: "In House",
        })
        .then(() => {
          getAll();
          handlePrint();
          modalCheckIn.value = false;
        });
    }
  } catch (error) {
    console.error(error);
  }
}

function toggleModal() {
  modal.value = !modal.value;
}

function toggleFilterModal() {
  modalFilter.value = !modalFilter.value;
}

function handleSearch(query) {
  search.value = query;
  getAll(startDate.value, endDate.value, filterStatus.value.status, query);
}

watch([startDate, endDate, filterStatus], () => {
  getAll(
    startDate.value,
    endDate.value,
    filterStatus.value.status,
    search.value
  );
});

onMounted(() => {
  getAll();
});

function handlePrint() {
  nextTick(() => {
    const printContents = document.getElementById("printArea").innerHTML;
    //const printWindow = window.open("", "", "width=80,height=auto");

    const now = new Date();
    const pad = (num) => String(num).padStart(2, "0");
    const formattedDate = `${now.getFullYear()}-${pad(
      now.getMonth() + 1
    )}-${pad(now.getDate())}_${pad(now.getHours())}-${pad(
      now.getMinutes()
    )}-${pad(now.getSeconds())}`;
    const filename = `CHECKIN-RECEIPT-deli-river-hotel-${formattedDate}`;

    // Penambahan buat iframe tersembunyi
    const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";
        iframe.setAttribute(
          "sandbox",
          "allow-modals allow-same-origin allow-scripts"
        );
        document.body.appendChild(iframe);

    const doc = iframe.contentDocument || iframe.contentWindow.document;

    // const htmlTemplate = `
    //   <!DOCTYPE html>
    //   <html>
    //     <head>
    //       <title>${filename}</title>
    //       <style>
    //         @page {
    //           size: 80mm auto;
    //           margin: 5mm;
    //         }
    //         body {
    //           font-family: sans-serif;
    //           padding: 5px;
    //         }
    //         h2 {
    //           margin-bottom: 5px;
    //         }
    //         p {
    //           margin: 0 0 5px;
    //         }
    //       </style>
    //     </head>
    //     <body>
    //       ${printContents}
    //     </body>
    //   </html>
    // `;

    // printWindow.document.write(htmlTemplate);
    // printWindow.document.close();
    // printWindow.focus();

    // setTimeout(() => {
    //   printWindow.print();
    //   printWindow.close();
    // }, 100);

    doc.open();
    doc.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>${filename}</title>
          <meta name="viewport" content="width=device-width,initial-scale=1.0">
          <style>
          @media print {
            
            @page {
              size: 80mm auto;    
            }
            body {
              font-family: "Consolas", monospace;
              font-weight: bold;
              font-size: 14px;
              margin: 10px;
              padding: 0;
            }
            h2 {
              font-size: 10px;
              margin: 0;
            }
            h3 {
              margin: 0;
            }
            h4 {
              margin: 0;
            }
            p {
              margin: 3px 0px;
            }
            .billing-detail {
              margin-top: -5px;
            }
            hr {
              margin-top: -5px;
            }
            tbody {
              margin: 0px;
            }
        }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    doc.close();

    // Tunggu iframe selesai load sebelum print
    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      // Bersihkan iframe setelah print
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    };
  });
}
</script>

<style scoped>
.bg-primary {
  background-color: #0d6efd !important;
}

.border-bottom {
  border-bottom: 1px solid #e9ecef !important;
}

.text-start {
  text-align: left !important;
}

.fs-4 {
  font-size: 1.5rem;
}

ul {
  padding-left: 0;
}

li span:first-child {
  min-width: 100px;
  flex-shrink: 0;
}

.billing li span:first-child {
  min-width: 160px;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:nth-child(2) {
  width: 10px;
  text-align: left;
  flex-shrink: 0;
  font-weight: bold;
}

.billing li span:last-child {
  flex: 1;
  font-weight: bold;
  word-wrap: break-word;
}

/* Style untuk extra charges */
.extra-charges {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
}

.extra-charge-item {
  padding: 4px 8px;
  background-color: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

/* style untuk print resi*/
@media print {
  body * {
    visibility: hidden;
  }
  #printArea,
  #printArea * {
    visibility: visible;
  }
  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }
  #printArea .situs {
    padding: 30px;
  }
  button {
    display: none !important;
  }
  .navbar,
  .footer,
  .btn {
    display: none;
  }
  .print-only {
    display: block !important;
  }
  .screen-only {
    display: none !important;
  }
}

/* Elemen hanya layar vs hanya print */
.print-only {
  display: none;
}
.screen-only {
  display: block;
}
.situs {
  padding: 20px;
  margin: 20px;
  color: red;
}
</style>
